import { ReactElement, useEffect, useState } from "react";
import { IDictionaryNumericKey, IProduction, IStrandProduction } from "../../../types";
import { TextField } from "@mui/material";
import { IAuxiliaryData } from "../types";
import { toTons } from "../../../system/utils";

interface IProps {
  productionData: IProduction[];
  auxiliaryData: IDictionaryNumericKey<IAuxiliaryData> | null;
}

interface IConsolidateData {
  totalBillets: number;
  totalBilletsD: number;
  totalWeight: number;
}


const ProductionHeader = ({ productionData, auxiliaryData }: IProps): ReactElement => {
  const [ consolidate, setConsolidate ] = useState<IConsolidateData>({ totalBillets: 0, totalWeight: 0, totalBilletsD: 0 });

  useEffect(() => {

    if(!auxiliaryData) {
      return;
    }

    let totalBillets = 0;
    let totalWeight = 0;
    let totalBilletsD = 0;

    productionData.forEach(order => {
      totalBillets += (order.productionMachines[0] as IStrandProduction).totalBillets;

      totalWeight += auxiliaryData[order.productionID] ? auxiliaryData[order.productionID].weight : 0;
      totalBilletsD += auxiliaryData[order.productionID] ? auxiliaryData[order.productionID].billets : 0;
    });

    setConsolidate({
      totalBillets, totalWeight, totalBilletsD
    });

  }, [productionData, auxiliaryData]);

  const keyBase = `${Date.now()}`;


  return (
    <div className="display-flex-row">
      <div className="flex-grow-1 display-flex-row flex-wrap" style={{ height: 100 }}>

        <TextField className="form-control"
          variant="standard"
          key={`${keyBase}-total-orders`}
           slotProps={{ input: { readOnly: true }}}
          label={"Total Orders"}
          size="small"
          defaultValue={productionData.length}/>

        <TextField className="form-control"
          variant="standard"
          key={`${keyBase}-total-billets`}
           slotProps={{ input: { readOnly: true }}}
          label={"Total Billets"}
          size="small"
          defaultValue={`${consolidate.totalBilletsD} / ${consolidate.totalBillets}`}/>

        <TextField className="form-control"
          variant="standard"
          key={`${keyBase}-total-weight`}
           slotProps={{ input: { readOnly: true }}}
          label={"Total Weight [US ton]"}
          size="small"
          defaultValue={toTons(consolidate.totalWeight).toFixed(1)}/>

      </div>
    </div>
  );
};

export default ProductionHeader;
